<template>
  <div class="login-container">
    <form @submit.prevent="login" class="login-form">
      <h1>Login</h1>
      
      <div class="form-group">
        <label for="username">Username</label>
        <input 
          type="text" 
          id="username" 
          v-model="username" 
          required
          placeholder="Enter your username"
        />
      </div>
      
      <div class="form-group">
        <label for="password">Password</label>
        <input 
          type="password" 
          id="password" 
          v-model="password" 
          required
          placeholder="Enter your password"
        />
      </div>
      
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
      
      <button type="submit" class="login-button">Login</button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  data() {
    return {
      username: '',
      password: '',
      errorMessage: ''
    }
  },
  methods: {
    login() {
      // Reset error message
      this.errorMessage = '';
      
      // Basic validation
      if (!this.username || !this.password) {
        this.errorMessage = 'Username and password are required';
        return;
      }
      
      // Here you would typically make an API call to authenticate
      // For demo purposes, we'll just simulate a successful login
      console.log('Login attempt with:', { username: this.username });
      
      // Simulate successful login and redirect
      // In a real app, you would check credentials with your backend
      if (this.username === 'admin' && this.password === 'password') {
        // Store authentication state (in a real app, use Vuex or similar)
        localStorage.setItem('isAuthenticated', 'true');
        
        // Redirect to home page or dashboard
        this.$router.push('/');
      } else {
        this.errorMessage = 'Invalid username or password';
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.login-form {
  width: 100%;
  max-width: 400px;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

h1 {
  text-align: center;
  margin-bottom: 2rem;
  color: #2c3e50;
}

.form-group {
  margin-bottom: 1.5rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
  color: #2c3e50;
}

input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

input:focus {
  outline: none;
  border-color: #42b983;
  box-shadow: 0 0 0 2px rgba(66, 185, 131, 0.2);
}

.login-button {
  width: 100%;
  padding: 0.75rem;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-button:hover {
  background-color: #3aa876;
}

.error-message {
  color: #e74c3c;
  margin-bottom: 1rem;
  text-align: center;
}
</style>
